import { createSelector } from 'reselect';
import _sortBy from 'lodash/sortBy';

import { staffAccounts } from 'store/saga/entities/bound';
import { USER_ROLE } from 'constants/logic';
import { selectUserVenues } from 'selectors/general';

export const selectStaffAccounts = state => (staffAccounts.loaded(state) ? staffAccounts.data(state) : []);

export const selectActiveAccounts = createSelector(selectStaffAccounts, staff => staff.filter(({ active }) => active));

export const selectSortedAccounts = createSelector(selectActiveAccounts, activeStaff =>
  _sortBy(activeStaff, ['firstName', 'lastName'])
);

export const selectOwnerAccounts = createSelector(selectSortedAccounts, staff =>
  staff.filter(({ role }) => role === USER_ROLE.OWNER)
);

export const selectManagerAccounts = createSelector(selectSortedAccounts, staff =>
  staff.filter(({ role }) => role === USER_ROLE.MANAGER)
);

export const selectFrontDeskAccounts = createSelector(selectSortedAccounts, staff =>
  staff.filter(({ role }) => role === USER_ROLE.FRONT_DESK)
);

export const selectStaffAccountsIsLoading = state => staffAccounts.loading(state);

export const selectUserVenueIds = createSelector(selectUserVenues, venues =>
  venues ? venues.map(({ venueId }) => venueId) : []
);
